/**
 * QRMaps Design System - Theme Provider
 *
 * Wraps the app with styled-components ThemeProvider
 * Makes theme accessible via props.theme in all styled components
 */

import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { theme } from './theme';

export const ThemeProvider = ({ children }) => {
  return (
    <StyledThemeProvider theme={theme}>
      {children}
    </StyledThemeProvider>
  );
};

export default ThemeProvider;